var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { InfoModalComponent } from "../../views/modal/info_modal.component";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { TranslateService } from "../../translate/translate.service";
var DepartedTableDetail = /** @class */ (function (_super) {
    __extends(DepartedTableDetail, _super);
    function DepartedTableDetail(activeModal, translate) {
        var _this = _super.call(this, activeModal) || this;
        _this.activeModal = activeModal;
        _this.translate = translate;
        _this.isLoad = false;
        _this.tableType = '';
        _this.stats = [];
        return _this;
    }
    DepartedTableDetail.prototype.ok = function () {
        this.close();
    };
    return DepartedTableDetail;
}(InfoModalComponent));
export { DepartedTableDetail };
